const integer = (value) => Number.isSafeInteger(value) && value >= 0;
const id = (value) => integer(value) && value > 0;
export function canUseOther(universe) {
  return (
    universe?.canAttendWithOther === true &&
    universe.radiusKm === 500 &&
    universe.state === 'COMPLETE' &&
    universe.pendingCount === 0 &&
    integer(universe.eligibleCount) &&
    universe.refusedCount === universe.eligibleCount
  );
}

/**
 * 5716: todas as placas da busca (veículos e implementos do cadastro); as que não podem ser
 * escolhidas vêm com `compatible: false` e o motivo do cooperplace-api.
 */
export function otherCandidates(data, context) {
  const seen = new Set();
  if (
    !data ||
    data.loadId !== context.item.loadId ||
    data.loadKind !== context.item.type ||
    !canUseOther(data.operationalUniverse) ||
    !integer(data.totalCount) ||
    !Array.isArray(data.data) ||
    data.data.length !== Math.min(data.totalCount, 25) ||
    data.data.some((row) => {
      const key = `${row?.assetType}:${row?.id}`;
      if (
        !row ||
        !['vehicle', 'wagon'].includes(row.assetType) ||
        !id(row.id) ||
        seen.has(key) ||
        typeof row.plate !== 'string' ||
        !row.plate.trim() ||
        (row.driver !== null &&
          (!id(row.driver?.id) ||
            (row.driver.name !== null && typeof row.driver.name !== 'string'))) ||
        !Array.isArray(row.wagons) ||
        !row.wagons.every((w) => id(w?.id) && typeof w.plate === 'string') ||
        typeof row.compatible !== 'boolean' ||
        (row.compatible
          ? row.reason !== null || (row.assetType === 'wagon' && row.driver !== null)
          : typeof row.reason?.code !== 'string' ||
            typeof row.reason.message !== 'string' ||
            !row.reason.message.trim())
      )
        return true;
      seen.add(key);
      return false;
    })
  )
    throw new Error('Resposta inválida de outros veículos. Atualize a consulta.');
  return data;
}
